module.exports = __webpack_public_path__ + "static/media/recruit_780_game.a5aef91e.png";